// extracted by mini-css-extract-plugin
module.exports =  {"page-spinner":"spinner__page-spinner___J29Cd","pageSpinner":"spinner__page-spinner___J29Cd","spin":"spinner__spin___IHlWv","small":"spinner__small___yhg0h"};